import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import * as React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useLanguage } from '../useLanguage';
import LocalizedRoute from './LocalizedRoute';

function LocalizedRouter(_ref) {
  var children = _ref.children;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  return /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/:lang",
    render: function render(props) {
      return /*#__PURE__*/React.createElement(LocalizedRoute, props, children);
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, function (routeProps) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: {
        pathname: "/".concat(currentLang),
        search: routeProps.location.search
      }
    });
  })));
}

export default LocalizedRouter;